let config = {
	id: null,
	env: null,
	src: 'https://www.googletagmanager.com/gtag/js?id=',
}

function loadScript() {
	window.addEventListener(
		'load',
		function (e) {
			const script = document.createElement('script')

			script.src = config.src + config.id

			document.head.appendChild(script)
		},
		{ once: true },
	)
}

function createGtag(Vue) {
	window.dataLayer = window.dataLayer || []

	function gtag() {
		window.dataLayer.push(arguments)
	}

	gtag('js', new Date())
	gtag('config', config.id)

	return (Vue.prototype.$gtag = Vue.$gtag = gtag)
}

export default function (Vue, options = {}) {
	config = { ...config, ...options }
	createGtag(Vue)

	if (config.id && config.env === 'production') {
		loadScript()
	}
}
